import React from 'react';
import{
    Row, Col,
    FormGroup, FormControl, ControlLabel
} from 'react-bootstrap';
import Checkbox from 'elements/CustomCheckbox/CustomCheckbox.jsx';
import Log from 'services/Log.jsx';

class Step1 extends React.Component{
    constructor(props){
        super(props);
        this.state = {
          projectName: "",
          nameError: null,
          tosError: null
        }
    }
    handleCheckbox = event => {
        const target = event.target;
        Log.debug(event.target.name);
        Log.debug(event.target.checked);
        this.setState({
            tosbox: target.checked
        });
    };

    isValidated(){
      if (this.state.projectName.length > 0 && this.state.tosbox) {
        this.props.setProjectName(this.state.projectName);
        this.props.setTos(this.state.tosbox);
        return true;
      } else {
        var newState = {};
        if (this.state.projectName.length <= 0) {
          newState.nameError = (<small className="text-danger">Invalid project name</small>);
        } else {
          newState.nameError = null;
        }
        if (!this.state.tosbox) {
          newState.tosError = (<small className="text-danger">You must agree to the ToS</small>);
        } else {
          newState.tosError = null;
        }
        this.setState(newState);
        return false;
      }
    }
    render(){
        return (
            <div className="wizard-step">
                <h5 className="text-center">Select a name for your project</h5>
                <Row>
                    <Col md={10} mdOffset={1}>
                        <FormGroup>
                            <ControlLabel>Project Name</ControlLabel>
                            <FormControl type="text" name="project_name" placeholder="ex: IoT Telemetry" onChange={(event) => this.setState({ projectName: event.target.value })}/>
                            {this.state.nameError}
                            <Checkbox
                                number={"tosbox"}
                                label={'By using this service you agree to the '}
                                onClick={this.handleCheckbox}
                                link={<a href="https://www.datagekko.com/tos"> ToS</a>}
                            />
                            {this.state.tosError}
                        </FormGroup>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default Step1;



// WEBPACK FOOTER //
// ./src/views/Forms/Wizard/Step1.jsx